import React, { useRef } from 'react';
import './profileJobHeader.css';
import { useAuth } from '../../../../context/AuthContext';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useSaveFavouriteJob from '../../../../hooks/useSaveFavouriteJob';
import useSignedImage from '../../../../hooks/useSignedImage';


const ProfileJobHeader = ({ data }) => {
  const {isAuthenticated} = useAuth()
  const navigate = useNavigate()
  const { id } = useParams();
  const location = useLocation();
  const {name, companyType, position, applicationId, imageUrl} = data
  const { imageUrl: signedImageUrl } = useSignedImage(imageUrl, '/default-restaurant.png');

  const { saveFavouriteJob, loading, error, success, isSaved } = useSaveFavouriteJob(id);

  // Handler for redirect
  const handleApplicationRedirect = () => {
    const applicationUrl = `/trabajos/${applicationId}/aplicar`;
    navigate(applicationUrl);
  };

  // Handler for scroll
  const handleScrollToForm = () => {
    const form = document.getElementById('apply-cta-section');
    if (form) {
      form.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Choose handler based on route
  const isApplyPage = location.pathname.endsWith('/aplicar');
  const handlePostular = isApplyPage ? handleScrollToForm : handleApplicationRedirect;

  const handleSaveJob = () => {
    
    if(!isAuthenticated) {
       navigate('/profesionales/entrar')
       return
    }
    
    saveFavouriteJob()
  }

  return (
    <div className="profile-job-header__container">
      <div className="profile-job-header__background-container">
      </div>
      <div className="profile-job-header__image-info-container ">
        <div className="profile-job-header__avatar-container">
          <img id="profile-job-header__img" src={signedImageUrl} alt="Avatar" />
        </div>
        <div className="profile-job-header__info-container">
          <div className="profile-job-header__text-info">
            <h1 className="profile-job-header__name">{position}</h1>
            <h2 className="profile-job-header__company">{name}</h2>
          </div>
          <div className="profile-job-header__buttons">
            <button onClick={handlePostular} className="profile-job-header__button">Postular</button>
            <button onClick={handleSaveJob} className="profile-job-header__button" disabled={isSaved}>
               {isSaved ? 'Guardado' : 'Guardar'}
            </button>
          </div>
        </div>  
      </div>
    </div>
  );
};

export default ProfileJobHeader;
